import React, { useContext, useEffect, useState } from "react";
import classes from "./Navbar.module.css";
import PersonIcon from "@mui/icons-material/Person";
import MenuIcon from "@mui/icons-material/Menu";
import { FaFacebookF } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FiSearch } from "react-icons/fi";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";

import {
  Avatar,
  Box,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Typography,
} from "@mui/material";
import { IoClose } from "react-icons/io5";
import "react-toastify/dist/ReactToastify.css";
import SearchBox from "./Search box/SearchBox";
import LanCurrSelect from "./Language and Currency/LanCurrSelect";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Link as LinkSS } from "react-scroll";
import * as Scroll from "react-scroll";
import { useDispatch, useSelector } from "react-redux";
import { removeUser } from "../../redux/productSlice";
import axios from "axios";
import AuthContext from "../authContext";

const Navbar = ({ toggle, carttoggle }) => {
  const language = useSelector(
    (state) => state.products.selectedLanguage[0].Language
  );
  const productData = useSelector((state) => state.products.productData);
  const favoriteData = useSelector((state) => state.products.favorites);
  const compareData = useSelector((state) => state.products.compare);
  const userInfo = useSelector((state) => state.products.userInfo);
  
  const [isSearchBar, setIsSearchBar] = useState(false);
  const settings = ["Profile", "Logout"];
  const dispatch = useDispatch(); 
  const [isScrolled, setIsScrolled] = useState(false);
  const [topDiv, setTopDiv] = useState(true);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();
  const path = useLocation().pathname;
  const location = path.split("/")[1];
  const scroller = Scroll.scroller;

  const NavigateAndScroll = async (props) => {
    if (path === "/") {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      await navigate("/");
      setTimeout(() => {
        scroller.scrollTo(props, {
          duration: 500,
          delay: 0,
          smooth: true,
          offset: 50,
        });
      }, 400);
    }
  };

  const logout = async () => {
    try {
      // Get the token from local storage
      const token = sessionStorage.getItem("token");

      // If token is not available, there's no need to logout
      if (!token) {
        return;
      }

      // Set up headers with the token
      const headers = {
        Accept: `application/json`,
        Authorization: `Bearer ${token}`,
      };

      // Send a POST request to the logout endpoint
      await axios.get(`${process.env.REACT_APP_TESTING_API}/logout`, {
        headers,
      });

      // Remove the token from local storage after successful logout
      localStorage.removeItem("token");

      dispatch(removeUser());
      navigate(`/login`);
      // Add any additional logic you may need, such as redirecting the user to the login page or updating the application state
    } catch (error) {
      // console.error("Error logging out:", error);
      // Handle any errors that occur during logout
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
      // Perform any additional actions after successful logout
    } catch (error) {
      // console.error("Error logging out:", error);
      // Handle logout error
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const isTop = window.scrollY > 80;
      if (isTop !== isScrolled) {
        setIsScrolled(isTop);
      }
    };
    document.addEventListener("scroll", handleScroll);
    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, [isScrolled]);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <>
    {isScrolled && <div style={{position: 'relative', height: '5em', width: '100%'}}></div>}
      <div className={`${isScrolled ? classes.fixednav_con : classes.headnav}`}>
            {topDiv && <div className={classes.topdiv}>
            <div style={{display:'flex', flexDirection:'row', columnGap:'1em'}}>
              <p style={{ margin: "auto 0", display:'flex',alignItems:"center" }}>
            {language === 'eng' ? authCtx.companySettings?.announcement_bar_text_en : authCtx.companySettings?.announcement_bar_text_fr } {" "}<br className={classes.mobileDisplay}/>
            <span style={{  cursor: "pointer",padding:'.3em 1em',border:"1px solid #fff",borderRadius:"20em",margin:"0 1em" }} onClick={()=>window.open(authCtx.companySettings?.announcement_bar_url , '_blank')}>
            {language === 'eng' ? authCtx.companySettings?.announcement_bar_link_en : authCtx.companySettings?.announcement_bar_link_fr }
            </span>
              </p>
              </div>
              <p className={classes.top_icon} onClick={()=>setTopDiv(false)}><IoClose /></p>
            </div>}
        <div className={classes.header}>
          <div className={classes.leftdiv}>
          <div className={classes.logocontainer}>
            {/* <Link to="/"> */}
              <img src={authCtx.companySettings.dark_icon} style={{cursor:"pointer"}} alt="logodark"  onClick={NavigateAndScroll}/>
            {/* </Link> */}
          </div>
              {<LanCurrSelect />}
              </div>
          {!isSearchBar && <div className={classes.headercontent}>
            <div className={classes.bottomdiv}>
              <div className={classes.options}>
              <div
                  className={classes.icon}
                  style={{ width: "40px", height: "40px", borderRadius: "50%" }}
                >
                    <IconButton
                      sx={{ p: 0 }}
                      onClick={() => {
                        setIsSearchBar(true);
                      }}
                    >
                    <FiSearch 
                        style={{
                          width: "30px",
                          height: "30px",
                          color: "var(--primary-color)",
                          margin: "6px",
                        }} />
                        </IconButton>
                </div>
                <div
                  style={{ width: "40px", height: "40px", borderRadius: "50%" }}
                  className={classes.icon}
                >
                  <Tooltip title={language === "eng" ? "Wishlist" : "Liste De Souhaits"}>
                    <IconButton
                      sx={{ p: 0 }}
                      onClick={() => {
                        if (userInfo) {
                          navigate(`/wishlist`);
                        } else {
                          navigate(`/login`);
                        }
                      }}
                    >
                      <FavoriteBorderIcon
                        alt=""
                        style={{
                          width: "30px",
                          height: "30px",
                          color: "var(--primary-color)",
                          margin: "6px",
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                  {favoriteData?.length !== 0 && (
                    <span
                      style={{
                        width: "1.5em",
                        height: "1.5em",
                        position: "absolute",
                        marginLeft: "-15px",
                        marginTop: "-52px",
                        borderRadius: "50%",
                        background: "var(--primary-color)",
                        textAlign: "center",
                        color: "#fff",
                      }}
                    >
                      {favoriteData?.length}
                    </span>
                  )}
                </div>
                <div
                  className={classes.icon}
                  style={{ width: "40px", height: "40px", borderRadius: "50%" }}
                >
                  <Tooltip title={language === "eng" ? "Cart" : "Panier"}>
                    <IconButton
                      sx={{ p: 0 }}
                      onClick={() => {
                          carttoggle();
                      }}
                    >
                      <ShoppingCartOutlinedIcon
                        style={{
                          width: "30px",
                          height: "30px",
                          color: "var(--primary-color)",
                          margin: "6px",
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                  {productData?.length !== 0 && (
                    <span
                      style={{
                        width: "1.5em",
                        height: "1.5em",
                        position: "absolute",
                        marginLeft: "-15px",
                        marginTop: "-52px",
                        borderRadius: "50%",
                        background: "var(--primary-color)",
                        textAlign: "center",
                        color: "#fff",
                      }}
                    >
                      {productData?.length}
                    </span>
                  )}
                </div>
                <div
                  className={classes.icon}
                  style={{ width: "40px", height: "40px", borderRadius: "50%" }}
                >
                    <IconButton
                      sx={{ p: 0 }}
                      onClick={toggle}
                    >
                    <MenuIcon 
                        style={{
                          width: "36px",
                          height: "36px",
                          color: "var(--primary-color)",
                          margin: "3px 6px",
                        }} />
                        </IconButton>
                </div>
              </div>
            </div>
          </div>}
           {isSearchBar && <div className={classes.search_con}><SearchBox setIsSearchBar={setIsSearchBar} isSearchBar={isSearchBar}/></div>}
        </div>
      </div>
      <div className={classes.navheight}></div>
      <div className={classes.mobilenav}>
        {!isSearchBar && <div
          style={{
            margin: "auto 0",
            width: "96%",
            position: "relative",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            padding: "0 2%",
          }}
        >
        <div className={classes.logomobile} onClick={NavigateAndScroll}>
          <img
            style={{ objectFit: "contain", margin: "0em auto" }}
            src={authCtx.companySettings.dark_icon}
            alt="logodark"
          />
        </div>
          <div className={classes.rightsidenavMobile}>
            <div className={classes.siderowrightmobile}>
                  <Tooltip title="Search">
                    <IconButton 
                      onClick={() => {
                        setIsSearchBar(true);
                      }} sx={{ p: 0 }}>
                      
                        <FiSearch
                          style={{
                            width: "25px",
                            height: "25px",
                            color: "var(--primary-color)",
                          }}
                        />
                    </IconButton>
                  </Tooltip>
            </div>
            <div className={classes.siderowrightmobile}>
              <Tooltip title="Cart">
                <IconButton
                  sx={{ p: 0 }}
                  onClick={() => {
                    navigate(`/cart`);
                  }}
                >
                  <ShoppingCartOutlinedIcon
                    style={{
                      width: "25px",
                      height: "25px",
                      color: "var(--primary-color)",
                      margin: "0",
                    }}
                  />
                </IconButton>
              </Tooltip>
              {productData?.length !== 0 && (
                <span
                  style={{
                    width: "1.5em",
                    height: "1.5em",
                    position: "absolute",
                    marginLeft: "-12px",
                    marginTop: "5px",
                    borderRadius: "50%",
                    background: "var(--primary-color)",
                    textAlign: "center",
                    color: "#fff",
                    fontSize: "12px",
                  }}
                >
                  {productData?.length}
                </span>
              )}
            </div>
            <div className={classes.siderowrightmobile}>
              <Tooltip title="Wishlist">
                <IconButton
                  sx={{ p: 0 }}
                  onClick={() => {
                    if (userInfo) {
                      navigate(`/wishlist`);
                    } else {
                      navigate(`/login`);
                    }
                  }}
                >
                  <FavoriteBorderIcon
                    style={{
                      width: "25px",
                      height: "25px",
                      color: "var(--primary-color)",
                      margin: "0",
                    }}
                  />
                </IconButton>
              </Tooltip>
              {favoriteData?.length !== 0 && (
                <span
                  style={{
                    width: "1.5em",
                    height: "1.5em",
                    position: "absolute",
                    marginLeft: "-12px",
                    marginTop: "5px",
                    borderRadius: "50%",
                    background: "var(--primary-color)",
                    textAlign: "center",
                    color: "#fff",
                    fontSize: "12px",
                  }}
                >
                  {favoriteData?.length}
                </span>
              )}
            </div>
            
            <div className={classes.siderowrightmobile}>
              <Tooltip title="menu">
                <IconButton
                  sx={{ p: 0 }}
                >
                  
            <MenuIcon 
                    style={{
                      width: "25px",
                      height: "25px",
                      color: "var(--primary-color)",
                      margin: "0",
                    }} onClick={toggle}/>
                </IconButton>
              </Tooltip>
            </div>
          </div>
        </div>}
        {isSearchBar && <div className={classes.search_con_mobile}><SearchBox setIsSearchBar={setIsSearchBar} isSearchBar={isSearchBar}/></div>}
      </div>
      <div className={classes.navheight}></div>
    </>
  );
};

export default Navbar;
